import { render } from "./singleBranchSummary.vue?vue&type=template&id=ea1df37c&scoped=true"
import script from "./singleBranchSummary.vue?vue&type=script&lang=js"
export * from "./singleBranchSummary.vue?vue&type=script&lang=js"

import "./singleBranchSummary.vue?vue&type=style&index=0&id=ea1df37c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea1df37c"]])

export default __exports__